// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React from 'react';
import { Tooltip, Typography } from '@mui/material';
import { Box, useTheme } from '@mui/system';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import stylesDef from './styles';

interface IProjectFolderBadgeProps {
  folderName: string;
  // Over a card's image the badge floats; in a row it sits inline with the other meta text.
  variant: 'overlay' | 'inline';
}

// AUT-6432: which folder a project is filed in, shown the same way wherever the project is -
// the dashboard's cards and rows, and the map rail's cards. One component so the three cannot
// describe the same project's folder differently.
export const ProjectFolderBadge = ({ folderName, variant }: IProjectFolderBadgeProps) => {
  const theme = useTheme();
  const styles = stylesDef(theme);

  return (
    <Tooltip title={folderName} arrow placement="top">
      <Box sx={[styles.badge, variant === 'overlay' ? styles.overlay : styles.inline]}>
        <FolderOutlinedIcon sx={styles.icon} fontSize="small" />
        <Typography variant="caption" sx={styles.text}>{folderName}</Typography>
      </Box>
    </Tooltip>
  );
};

export default ProjectFolderBadge;
